module.exports = __webpack_public_path__ + "static/tanzvereinigung-3afc417a37d0fffed7d5d1392e0ece27.jpg";